export const data: Record<string, any> = {};
